import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';

import CustomTeamImageWithDefault from '@/components/shared/custom/CustomTeamImageWithDefault';

const FixtureGoalsCard = ({ fixturePrediction, includeHome, includeAway }) => {
    if (!fixturePrediction) {
        return null;
    }

    const home = fixturePrediction?.teams?.home;
    const away = fixturePrediction?.teams?.away;

    const getTableRows = (rows, isBold) => {
        const fontWeight = isBold ? 600 : 400;
        return (
            <TableRow>
                {rows.map((row, index) => (
                    <TableCell
                        align={index === 0 ? 'left' : 'center'}
                        key={index}
                        colSpan={3}
                        className="first-row"
                        style={{ fontWeight: fontWeight }}
                    >
                        {row}
                    </TableCell>
                ))}
            </TableRow>
        );
    };

    const getSingleRow = (team) => {
        if (!team) return null;

        return (
            <TableRow>
                <TableCell align={'left'} colSpan={12}>
                    <CustomTeamImageWithDefault
                        teamId={team.id}
                        alt={'equipo'}
                        width={20}
                        height={20}
                    ></CustomTeamImageWithDefault>
                    <span className="title-tabs">{team.name}</span>
                </TableCell>
            </TableRow>
        );
    };

    const getTablesData = (team) => {
        if (!team) {
            return null;
        }

        return (
            <TableContainer component={Paper} className="datos-table-container mb-25">
                <Table className="data-table-goals" size={'small'} aria-label="simple table">
                    <TableHead>
                        {getSingleRow(team)}
                        {getTableRows(['', 'Local', 'Visitante', 'Total'])}
                        {getTableRows(['Goles', '', '', ''], true)}
                    </TableHead>
                    <TableBody>
                        {getTableRows([
                            'A favor',
                            team.league.goals.for.total.home,
                            team.league.goals.for.total.away,
                            team.league.goals.for.total.total,
                        ])}
                        {getTableRows([
                            'En contra',
                            team.league.goals.against.total.home,
                            team.league.goals.against.total.away,
                            team.league.goals.against.total.total,
                        ])}
                    </TableBody>
                </Table>
                <Table className="data-table-goal-average" size={'small'} aria-label="simple table">
                    <TableHead>{getTableRows(['Promedio de goles', '', '', ''], true)}</TableHead>
                    <TableBody>
                        {getTableRows([
                            'A favor',
                            team.league.goals.for.average.home,
                            team.league.goals.for.average.away,
                            team.league.goals.for.average.total,
                        ])}
                        {getTableRows([
                            'En contra',
                            team.league.goals.against.average.home,
                            team.league.goals.against.average.away,
                            team.league.goals.against.average.total,
                        ])}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    return (
        <div className="fixture-predictions-container">
            {includeHome && getTablesData(home)}
            {includeAway && getTablesData(away)}
        </div>
    );
};

export default FixtureGoalsCard;
